document.addEventListener('DOMContentLoaded', () => {

let productsTab = [...document.querySelectorAll('.product-tabs-products__tabs .product-tab')];
let productsContent = [...document.querySelectorAll('.product-tabs-products__container .product-tabs__product')];


productsTab.forEach((tab, i) => {
    tab.addEventListener('click', () => {
        productsTab.forEach(tab => tab.classList.remove('active'));
        productsContent.forEach(content => content.classList.remove('active'));
        tab.classList.add('active');
        productsContent[i].classList.add('active');
    });
});

});